import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

interface EditAreaParams {
	id: number;
	payload: Record<string, unknown>;
}

const editArea = async ({ id, payload }: EditAreaParams) => {
	const response = await cmsClient.patch(
		`/homepage/admin/store/area/${id}/`,
		payload
	);

	return response.data;
};

const useEditArea = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Area updated" />, {
			hideProgressBar: true
		});
	};

	const onError = (error: unknown) => {
		const detail = (error as any)?.response?.data;
		const message =
			detail?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : null) ??
			"Something went wrong, try again";
		const safeMessage = message.length > 200 ? message.slice(0, 200) + "..." : message;

		toast.error(<CustomToast type="Error" message={safeMessage} />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["admin-areas"]);
	};

	return useMutation(editArea, { onSuccess, onError, onSettled });
};

export default useEditArea;
